import { render, staticRenderFns } from "./diagnosticResults.vue?vue&type=template&id=5cab8249&scoped=true&"
import script from "./diagnosticResults.vue?vue&type=script&lang=js&"
export * from "./diagnosticResults.vue?vue&type=script&lang=js&"
import style0 from "./diagnosticResults.vue?vue&type=style&index=0&id=5cab8249&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cab8249",
  null
  
)

export default component.exports